import { vpApi } from './vpApi'

type ContactFormPayload = {
  name: string
  email: string
  subject: string
  message: string
}

const submitContactForm = (payload: ContactFormPayload) => {
  return vpApi.post('/v1/contact/', { payload })
}

export type CeleryTaskStatusResponse<T = unknown> = {
  task_id: string
  task_status: 'PENDING' | 'SUCCESS' | 'FAILURE'
  task_result: T
}

// Celery task status will be moved away from cvat namespace
const getCeleryTaskStatus = async (celeryTaskId: string) => {
  const res = await vpApi.get<CeleryTaskStatusResponse>(
    `/v1/cvat/celery-task/${celeryTaskId}/status/`
  )
  return res.data
}

const triggerServerException = () => {
  return vpApi.post('/v1/trigger-error/')
}

export const generalApi = {
  submitContactForm,
  getCeleryTaskStatus,
  triggerServerException
}
